const experiences = [
	{
		id: 1,
		company: 'Wildfire Systems',
		position: 'Senior Software Engineer',
		startDate: 'July 2026',
		endDate: 'Present',
		location: 'Remote',
		duration: 'July 2026 – Present · Remote',
		summary:
			'Defined and enforced frontend standards across Chrome, Safari, and iOS. Rebuilt the cross-platform architecture with server-side rendering, cutting build times ~75%, and architected a data-driven deployment system that reduced rollouts from weeks to near-instant.',
		skills: [
			'TypeScript',
			'React',
			'JavaScript',
			'Chrome Extensions',
			'Safari Extensions',
			'iOS Safari',
			'SSR',
			'Architecture',
			'Technical Leadership',
		],
		achievements: [
			{
				title: 'Cross-Platform Frontend Standards',
				description: [
					'Defined and enforced frontend standards across Chrome, Desktop Safari, and iOS Safari extensions, ensuring predictable behavior and stable releases by balancing partner requirements with long-term maintainability.',
				],
			},
			{
				title: 'Cross-Platform Template Rebuild & Parity Enforcement',
				description: [
					'Rebuilt cross-platform frontend platform architecture using server-side rendering, resolving multi-year drift and cross-platform inconsistencies across Chrome, Safari, and iOS, reducing build times from ~51s to ~13s (~75%).',
					'Improved code parity across platforms, reduced bugs caused by divergence, and simplified onboarding for new engineers.',
					'Enabled features to be implemented once and deployed consistently across all supported environments.',
				],
			},
			{
				title: 'Data-Driven Deployment System',
				description: [
					'Architected a data-driven deployment system, leading complex architectural decisions and cross-team coordination to enable rapid, remote, and personalized updates, reducing rollout time from weeks to near-instant.',
					'Identified structural limitations in existing deployment workflows, where multi-platform client releases introduced delays, risk, and operational friction, especially for partner-facing features.',
					'Researched and evaluated architectural approaches under browser security, CSP, and platform constraints, assessing tradeoffs between flexibility, safety, and long-term maintainability.',
					'Designed the system to safely render remotely-defined HTML and CSS, incorporating sanitization, caching strategies, and controlled update surfaces to meet Chrome Web Store and App Store requirements.',
					'Laid the foundation for future capabilities, including faster iteration cycles, targeted personalization, and remote configuration so updates could ship without client-side releases.',
				],
			},
			{
				title: 'Architectural Guidance & Mentorship',
				description: [
					'Provided architectural guidance, mentorship, and code review support for multiple teams, establishing best practices that improved code clarity and ensured reliable behavior across differing runtime environments.',
				],
			},
		],
	},
	{
		id: 2,
		company: 'Wildfire Systems',
		position: 'Software Engineer Technical Lead',
		startDate: 'Jan 2025',
		endDate: 'July 2026',
		location: 'Remote',
		duration: 'Jan 2025 – July 2026 · Remote',
		summary:
			'Led development of the AICP system for dynamic, user-context-driven product detection and cashback activation across AI platforms. Collaborated with backend, QA, design, and PM to shape a more structured release process.',
		skills: [
			'TypeScript',
			'React',
			'JavaScript',
			'Chrome Extensions',
			'Safari Extensions',
			'AI Integration',
			'Architecture',
			'Technical Leadership',
		],
		achievements: [
			{
				title: 'AI Conversation Page (AICP) System',
				description: [
					'Led development of the AICP system, enabling dynamic, user-context-driven product detection and cashback activation across multiple platforms, and standardizing integrations into reusable modules.',
					'Built product-entity detection and decoration logic adapted for AI chat interfaces rather than traditional search engine results pages (SERPs).',
					'Implemented automated cashback activation flows compatible with diverse partner requirements.',
				],
			},
			{
				title: 'Cross-Functional Collaboration & Release Planning',
				description: [
					'Collaborated with backend, QA, design, and PM teams to define specifications and plan releases, offering critical feedback to balance feasibility and regression risk, and shaping a more structured release process.',
					'Coordinated across functions to reduce ambiguity and guide features from exploration → planning → delivery.',
				],
			},
			{
				title: 'AI-Assisted Engineering Practices',
				description: [
					'Used AI tools such as Claude, Cursor, ChatGPT, and Copilot to evaluate design approaches, explore implementation options, and accelerate iteration during development.',
					'Maintained full ownership of correctness, security, and architectural decisions by treating AI output as input for reasoning rather than authoritative solutions.',
				],
			},
		],
	},
	{
		id: 3,
		company: 'Wildfire Systems',
		position: 'Software Engineer',
		startDate: 'Nov 2023',
		endDate: 'Jan 2025',
		location: 'Remote',
		duration: 'Nov 2023 – Jan 2025 · Remote',
		summary:
			'Delivered features across 20+ partner-branded browser extensions with 2M+ users. Achieved WCAG 2.1 AA accessibility compliance for Citi Bank, resolving 50+ violations, and implemented Swift-based host app authentication for iOS Safari.',
		skills: [
			'TypeScript',
			'React',
			'Chrome Extensions',
			'Safari Extensions',
			'Swift',
			'Accessibility',
			'WCAG 2.1',
			'CI/CD',
			'GitHub Actions',
		],
		achievements: [
			{
				title: 'Core Extension Development Across 20+ Partner Apps',
				description: [
					'Delivered features and platform improvements across more than 20 partner-branded browser extensions with a combined install base of 2M+ users across Chrome, Safari, and iOS Safari.',
					'Ensured consistent behavior across highly heterogeneous environments and partner configurations.',
				],
			},
			{
				title: 'Accessibility (ADA / WCAG 2.1 AA) Compliance for Citi Bank',
				description: [
					'Implemented accessibility remediation for Citi Bank partner extensions in collaboration with TPGI auditors, addressing 50+ WCAG 2.1 AA violations across semantics, keyboard navigation, focus management, and screen reader behavior.',
					'Evaluated auditor recommendations, identified incorrect or incomplete guidance, and proposed alternative implementations based on independent research and practical testing.',
					'Coordinated directly with TPGI, product management, client success, and engineering leadership to review findings, validate solutions, and align on corrected accessibility approaches.',
					'Advocated for improved accessibility testing practices by introducing physical devices for validation, replacing simulator-only testing to ensure real-world compliance.',
					'Established improved accessibility patterns and standards that informed subsequent partner implementations and template updates.',
				],
			},
			{
				title: 'Host App Authentication Flows',
				description: [
					'Implemented secure authentication flows between a native iOS host app and the Safari Web Extension Handler to support automatic user login.',
					'Designed and implemented reliable cross-process communication in Swift between the host app and extension, accounting for lifecycle boundaries, app state changes, and failure modes.',
					'Reduced user friction during activation while ensuring authentication correctness across devices, sessions, and extension states.',
				],
			},
			{
				title: 'CI/CD & Release Automation',
				description: [
					'Maintained and expanded GitHub Actions pipelines to improve build reliability, standardize release behavior, and reduce deployment risk across partner repositories.',
					'Introduced monorepo tooling and coordinated release workflows to support safer, synchronized deployments across multiple extensions.',
				],
			},
		],
	},
];

export default experiences;
